const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Returns month name from Date
 * @param {Date} d - date
 * @returns {String}
 */
const monthName = (d = new Date()) => months[d.getMonth()];

/**
 * Argument is N, then returns 0N.
 * Argument is NN, then returns NN.
 * @param {Number} n - number
 */
const addZeroIfOneNumber = (n = 0) => {
  if (n <= 9) {
    return `0${n}`;
  }
  return n;
};

/**
 * Returns string like `17:00 1 March`
 * @param {Date} d - date
 */
const timeDateMonthString = (
  d = new Date(),
  format = (dateArgument, date, hours, minutes) => `${hours}:${minutes}, ${date} ${monthName(dateArgument)}`,
) => {
  const hours = d.getHours();
  const minutes = d.getMinutes();
  const date = d.getDate();

  const hoursNormal = addZeroIfOneNumber(hours);
  const minutesNormal = addZeroIfOneNumber(minutes);

  return format(d, date, hoursNormal, minutesNormal);
};

/**
 * Returns string from date like 01.03.2020
 * @param {Date} d
 */
const getBeautyDateString = (d = new Date()) => {
  return `${addZeroIfOneNumber(d.getDate())}.${addZeroIfOneNumber(
    d.getMonth() + 1,
  )}.${d.getFullYear()}`;
};

export {
  monthName,
  addZeroIfOneNumber,
  timeDateMonthString,
  getBeautyDateString,
};
